import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Button, Grid, Typography, Divider, Box } from '@material-ui/core'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { GRAY_COLORS } from 'asterX-UI'
import PageContainerDesktop from 'components/PageContainer/layout/PageContainer.desktop'
import { FieldInfoNG } from 'asterX-UI/DataDisplay'
import MobilePhotoSlider from 'components/Desktop/PhotoSlider/MobilePhotoSlider'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles(theme => ({
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: -20,
    marginBottom: 20,
    gap: theme.spacing(1)
  },
  heading: {
    fontSize: 18,
    fontWeight: 600,
    color: GRAY_COLORS[800]
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    color: GRAY_COLORS[700]
  },
  sliderContainer: {
    position: 'relative',
    borderRadius: 8,
    overflow: 'hidden',
    border: `1px solid ${GRAY_COLORS[200]}`
  },
  slider: {
    maxHeight: 300
  },
  slide: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: GRAY_COLORS[50]
  },
  dataContainer: {
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginTop: theme.spacing(2)
    }
  }
}))

const infoRowProps = {
  labelStyle: { width: 140, color: GRAY_COLORS[600] },
  rootStyle: { alignItems: 'center', marginBottom: 6 },
  valueStyle: { fontWeight: 500 }
}

const formatPrice = value => {
  if (!value) return '-'
  return value.toString().thousandSeparator
    ? value.toString().thousandSeparator()
    : Number(value).toLocaleString('ru-RU')
}

const PLACEHOLDER_IMG = '/static/media/car_placeholder.32a813e395be6b938a41.jpg'

const TireData = ({ tire, onClose }) => {
  const classes = useStyles()

  if (!tire) return <LoaderBackdrop loading />

  const {
    photos,
    mark,
    model,
    id,
    branch,
    season,
    radius,
    rimSetAmount,
    width,
    height,
    setAmount,
    year,
    week,
    averageWear,
    price,
    rrcPrice,
    newSetPrice
  } = tire
  console.log('tire', tire)
  const photoList = photos?.length > 0 ? photos : [PLACEHOLDER_IMG]

  return (
    <PageContainerDesktop
      customHeader={
        <div className={classes.headerContainer}>
          <Typography variant="h5" className={classes.heading}>
            Превью комплекта шин
          </Typography>
          <Button
            style={{ marginRight: '-20px' }}
            variant="text"
            color="default"
            onClick={onClose}
          >
            <CloseIcon />
          </Button>
        </div>
      }
    >
      <MobilePhotoSlider
        photos={photoList}
        className={classes.slider}
        slideClassName={classes.slide}
      />

      <Grid>
        <Box className={classes.dataContainer}>
          <Typography className={classes.sectionTitle}>Основное</Typography>
          <FieldInfoNG label="ID" {...infoRowProps}>
            {id || '-'}
          </FieldInfoNG>
          <FieldInfoNG label="Название" {...infoRowProps}>
            {mark?.name || '-'} {model?.name || ''}
          </FieldInfoNG>
          <FieldInfoNG label="Автосалон" {...infoRowProps}>
            {branch?.name || '-'}
          </FieldInfoNG>

          <Divider style={{ margin: '12px 0' }} />

          <Typography className={classes.sectionTitle}>Параметры</Typography>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <FieldInfoNG label="Сезонность" {...infoRowProps}>
                {season || '-'}
              </FieldInfoNG>
              <FieldInfoNG label="Диаметр" {...infoRowProps}>
                {radius || '-'}
              </FieldInfoNG>
              <FieldInfoNG label="Ширина" {...infoRowProps}>
                {width || '-'}
              </FieldInfoNG>
              <FieldInfoNG label="Наличие дисков" {...infoRowProps}>
                {!rimSetAmount ? `Нет` : 'Есть'}
              </FieldInfoNG>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FieldInfoNG label="Шин в комплекте" {...infoRowProps}>
                {setAmount || '0'}
              </FieldInfoNG>
              <FieldInfoNG label="Высота" {...infoRowProps}>
                {height || '-'}
              </FieldInfoNG>
              <FieldInfoNG label="Год/Неделя" {...infoRowProps}>
                {year || '-'} / {week || '-'}
              </FieldInfoNG>
              <FieldInfoNG label="Износ" {...infoRowProps}>
                {averageWear ? `${averageWear}%` : '-'}
              </FieldInfoNG>
            </Grid>
          </Grid>

          <Divider style={{ margin: '12px 0' }} />

          <Typography className={classes.sectionTitle}>Стоимость</Typography>
          <FieldInfoNG label="Цена (₸)" {...infoRowProps}>
            {formatPrice(price)} ₸
          </FieldInfoNG>
          <FieldInfoNG label="РРЦ (₸)" {...infoRowProps}>
            {formatPrice(rrcPrice)} ₸
          </FieldInfoNG>
          <FieldInfoNG label="Цена за новый (₸)" {...infoRowProps}>
            {formatPrice(newSetPrice)} ₸
          </FieldInfoNG>
        </Box>
      </Grid>
    </PageContainerDesktop>
  )
}

export default TireData
